"use client"

import { Col, Row } from "antd"
import { TypeStoreDetail } from "@/lib/redux/features/store/type"
import BannerSkeleton from "@/components/layouts/CategoryLayout/Banner/index.skeleton"
import DescriptionSkeleton from "../Description/index.skeleton"
import CategoryProductsItemSkeleton from "../../Home/Categories/CategoryProductsItem.skeleton"
import { getPageSizeProducts } from "@/utils/category/getPageSizeProducts"

const CategoryProductsSkeleton = ({ store }: { store: TypeStoreDetail }) => {

  return (
    <Row justify="center">
      <BannerSkeleton store={store} />
      {!!store.home_description?.content && store.home_description?.content !== '<p></p>' && (<DescriptionSkeleton />)}
      <Row justify="center" className="page">
        <Col className="page__section">
          <CategoryProductsItemSkeleton store={store} countProduct={getPageSizeProducts(store)} customGridProducts={store.grid_products} />
        </Col>
      </Row>
    </Row>
  )
}

export default CategoryProductsSkeleton